<div class="row">
    <div class="col-sm-12" style="display: flex; justify-content: space-between;">
        <h3 class="col-sm-6"> Facturation du {{this.bp.code}} {{this.bp.societe ? '('+ this.bp.societe.code + ')' :''}}</h3>
        <div class="col-sm-6" style=" justify-content: space-between;">
            <button color="default" mat-raised-button type="button" (click)="close()">
                <mat-icon>arrow_back</mat-icon>Retour à la liste
            </button>
            <button color="primary" mat-raised-button type="button" (click)="print()">
                <mat-icon>print</mat-icon>Imprimer
            </button>
            <button color="success" mat-raised-button type="button" (click)="facture()">
                <mat-icon>check</mat-icon>Facturer
            </button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm-12" style="padding: 0px!important">
        <div class="row">
            <div class="col-sm-12">
                 <app-bp-form [form]="bpForm" [detailInfo]="detailBpInfo" [amountHT]="bpLineHTs" [amountTTC]="bpLineTTCs"
                 [amountTVA]="bpLineTVAs"></app-bp-form>
            </div>
        </div>
        <div class="row"></div>
        <div class="row">
            <mat-card>
                <mat-card-content>
                    <app-bp-line-facturation-array class="row" [form]="bpForm" [detailInfos]="DetailBpLineinfos"> </app-bp-line-facturation-array>
                </mat-card-content>
            </mat-card>
        </div>


    </div>
</div>